// TODO: Import React module
import React, { useEffect, useState, } from 'react';

// TODO: Import MUI module
import {
    Box, Button, Card, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Link,
    Typography, Grid,
} from '@mui/material';

// TODO: Import MUI icon
import {
    Apple, CalendarMonth, Class, EnergySavingsLeaf, EventAvailable, Fence, FilterVintage, Forest, Grass,
    Height, LightMode, LocalFlorist, NotificationsPaused, Spa, Speed, Straighten, Warning,
    Thermostat, Update, WaterDrop,
} from '@mui/icons-material';

// TODO: Import context
import { Context, fetchData } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import Slogan from './PlantInfo/Slogan.js';
import Info from './PlantInfo/Info.js';
import GridImages from './PlantInfo/GridImages.js';
import BoxIntroBoard from './PlantInfo/BoxIntroBoard.js';

const PlantInfo = ({ plant, setPlant }) => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component PlantInfo Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const [info, setInfo] = useState(null);

    // TODO: Define event
    const handleClose = () => {
        setInfo(null);
        setPlant(null);
    };

    const getData = () => {
        (async () => {
            const formData = new FormData();
            formData.append('action', 'BlessedBotanicals_GetPlantInfo');
            formData.append('id', plant);

            fetchData(formData, (result) => {
                if (result.length > 0) {
                    setInfo(result[0]);
                }
            })
        })();
    }

    useEffect(getData, [plant]);

    // TODO: Return component
    const PlantTypeTransform = ({ text }) => {
        const types = text.split(', ').map(item => item.trim());

        const typeMappings = [
            { type: "香草", component: <Chip label="☘️香草" size="small" sx={{ fontSize: '1rem', m: 0.5 }} variant="outlined" /> },
            { type: "多肉植物", component: <Chip label="🌵多肉植物" size="small" sx={{ fontSize: '1rem', m: 0.5 }} variant="outlined" /> },
            { type: "灌木", component: <Chip label="🌳灌木" size="small" sx={{ fontSize: '1rem', m: 0.5 }} variant="outlined" /> },
            { type: "樹木", component: <Chip label="🌲樹木" size="small" sx={{ fontSize: '1rem', m: 0.5 }} variant="outlined" /> },
            { type: "藤蔓", component: <Chip label="🌿藤蔓" size="small" sx={{ fontSize: '1rem', m: 0.5 }} variant="outlined" /> },
        ];

        return (
            types.map(type => {
                const mapping = typeMappings.find(m => m.type === type);
                return mapping ? mapping.component : <Chip label={type} size="small" sx={{ fontSize: '1rem', m:0.5 }} variant="outlined" />;
            })
        )
    };

    const SeasonTransform = ({ text }) => {
        const seasons = text.split(', ').map(item => item.trim());

        const seasonMappings = [
            { season: "春", emoji: "🌱" },
            { season: "夏", emoji: "☀️" },
            { season: "秋", emoji: "🍁" },
            { season: "冬", emoji: "❄️" },
        ];

        return (
            seasons.map(season => {
                const mapping = seasonMappings.find(m => season.includes(m.season));
                return (
                    <Chip
                        label={mapping ? `${mapping.emoji} ${season}` : season}
                        size="small"
                        sx={{ fontSize: '1rem', m:0.5 }}
                        variant="outlined"
                    />
                );
            })
        )
    };

    const ColorTextTransform = ({ text }) => {
        const colors = text.split(', ').map(item => item.trim());

        const colorMappings = [
            { color: "紅色", component: <Chip label="紅色" size="small" sx={{ backgroundColor: 'red', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "綠色", component: <Chip label="綠色" size="small" sx={{ backgroundColor: 'green', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "藍色", component: <Chip label="藍色" size="small" sx={{ backgroundColor: 'blue', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "棕色", component: <Chip label="棕色" size="small" sx={{ backgroundColor: 'brown', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "紫紅色", component: <Chip label="紫紅色" size="small" sx={{ backgroundColor: '#CC397B', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "紫色", component: <Chip label="紫色" size="small" sx={{ backgroundColor: 'purple', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "藍紫色", component: <Chip label="藍紫色" size="small" sx={{ backgroundColor: '#8A2BE2', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "灰色", component: <Chip label="灰色" size="small" sx={{ backgroundColor: 'grey', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "黑色", component: <Chip label="黑色" size="small" sx={{ backgroundColor: 'black', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "銅色", component: <Chip label="銅色" size="small" sx={{ backgroundColor: '#B87333', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "紅褐色", component: <Chip label="紅褐色" size="small" sx={{ backgroundColor: 'Maroon', color: 'white', fontSize: '1rem', m:0.5 }} /> },
            { color: "橘色", component: <Chip label="橘色" size="small" sx={{ backgroundColor: 'orange', fontSize: '1rem', m:0.5 }} /> },
            { color: "金色", component: <Chip label="金色" size="small" sx={{ backgroundColor: 'gold', fontSize: '1rem', m:0.5 }} /> },
            { color: "粉色", component: <Chip label="粉色" size="small" sx={{ backgroundColor: 'pink', fontSize: '1rem', m:0.5 }} /> },
            { color: "銀色", component: <Chip label="銀色" size="small" sx={{ backgroundColor: 'silver', fontSize: '1rem', m:0.5 }} /> },
            { color: "藕荷色", component: <Chip label="藕荷色" size="small" sx={{ backgroundColor: '#E0B0FF', fontSize: '1rem', m:0.5 }} /> },
            { color: "淡紫色", component: <Chip label="淡紫色" size="small" sx={{ backgroundColor: '#E6E6FA', fontSize: '1rem', m:0.5 }} /> },
            { color: "黃色", component: <Chip label="黃色" size="small" sx={{ backgroundColor: 'yellow', fontSize: '1rem', m:0.5 }} variant="outlined" /> },
            { color: "奶油色", component: <Chip label="奶油色" size="small" sx={{ backgroundColor: '#FFFDD0', fontSize: '1rem', m:0.5 }} variant="outlined" /> },
            { color: "白色", component: <Chip label="白色" size="small" sx={{ backgroundColor: 'white', fontSize: '1rem', m:0.5 }} variant="outlined" /> },
        ];

        return (
            colors.map(color => {
                const mapping = colorMappings.find(m => m.color === color);
                return mapping ? mapping.component : <Chip label={color} size="small" sx={{ m:0.5 }} variant="outlined" />;
            })
        );
    };

    return (
        <Dialog fullWidth={true} maxWidth="xl" open={Boolean(info)} onClose={handleClose}>
            {Boolean(info) &&
                <>
                    <DialogTitle>{language === 'CHI' ? info.CName : info.EName}</DialogTitle>
                    <DialogContent>
                        <Link id="BoxFirst" />
                        <Slogan id={plant} slogan={info.Name ? info.Symbolism.split(', ') : info.Slogan.split(';')} />
                        <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h4">
                            {info.Name}
                        </Typography>
                        {info.Nickname && <Typography sx={{ mt: 2 }} variant="body1">
                            別名: {info.Nickname}
                        </Typography>}
                        <Typography sx={{ mt: 2 }} variant="body1">
                            {info.Description}
                        </Typography>
                        <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                            科學分類
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
                            {info.Species && <Card sx={{ backgroundColor: 'primary.light', p: 1.5 }}>
                                <Typography sx={{ fontWeight: 'bold' }} variant="body1">種</Typography>
                                <Typography variant="body1">{info.Species}</Typography>
                            </Card>}
                            <Card sx={{ backgroundColor: 'primary.light', p: 1.5 }}>
                                <Typography sx={{ fontWeight: 'bold' }} variant="body1">屬</Typography>
                                <Typography variant="body1">{info.Genus}</Typography>
                            </Card>
                            <Card sx={{ backgroundColor: 'primary.light', p: 1.5 }}>
                                <Typography sx={{ fontWeight: 'bold' }} variant="body1">科</Typography>
                                <Typography variant="body1">{info.Family}</Typography>
                            </Card>
                            <Card sx={{ backgroundColor: 'primary.light', p: 1.5 }}>
                                <Typography sx={{ fontWeight: 'bold' }} variant="body1">目</Typography>
                                <Typography variant="body1">{info.Order}</Typography>
                            </Card>
                            <Card sx={{ backgroundColor: 'primary.light', p: 1.5 }}>
                                <Typography sx={{ fontWeight: 'bold' }} variant="body1">綱</Typography>
                                <Typography variant="body1">{info.Class}</Typography>
                            </Card>
                            <Card sx={{ backgroundColor: 'primary.light', p: 1.5 }}>
                                <Typography sx={{ fontWeight: 'bold' }} variant="body1">門</Typography>
                                <Typography variant="body1">{info.Phylum}</Typography>
                            </Card>
                        </Box>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            {info.Toxicity && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Warning color="error" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        毒性
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.Toxicity}</Typography>
                            </Grid>}
                            {info.Weeds && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Grass color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        雜草
                                    </Typography>
                                </Box>
                            </Grid>}
                            {info.Lifespan && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Update color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        生長周期
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.Lifespan}</Typography>
                            </Grid>}
                            {info.PlantType && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Class color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">植物類型</Typography>
                                </Box>
                                <PlantTypeTransform text={info.PlantType} />
                            </Grid>}
                            {info.BloomTime && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Spa color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        花期
                                    </Typography>
                                </Box>
                                <SeasonTransform text={info.BloomTime} />
                            </Grid>}
                            {info.HarvestTime && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <EventAvailable color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        果期
                                    </Typography>
                                </Box>
                                <SeasonTransform text={info.HarvestTime} />
                            </Grid>}
                            {info.PlantHeight && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Height color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        植株高度
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.PlantHeight}</Typography>
                            </Grid>}
                            {info.Spread && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Straighten color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        冠直徑
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.Spread}</Typography>
                            </Grid>}
                            {info.LeafColor && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <EnergySavingsLeaf color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        葉顏色
                                    </Typography>
                                </Box>
                                <ColorTextTransform text={info.LeafColor} />
                            </Grid>}
                            {info.FlowerSize && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <FilterVintage color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        花直徑
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.FlowerSize}</Typography>
                            </Grid>}
                            {info.FruitColor && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Apple color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        果顏色
                                    </Typography>
                                </Box>
                                {<ColorTextTransform text={info.FruitColor} />}
                            </Grid>}
                            {info.FlowerColor && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <LocalFlorist color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        花顏色
                                    </Typography>
                                </Box>
                                {<ColorTextTransform text={info.FlowerColor} />}
                            </Grid>}
                            {info.StemColor && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Forest color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        莖顏色
                                    </Typography>
                                </Box>
                                {<ColorTextTransform text={info.StemColor} />}
                            </Grid>}
                            {info.Dormancy && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <NotificationsPaused sx={{ color: 'grey' }} />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        休眠狀態
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.Dormancy}</Typography>
                            </Grid>}
                            {info.LeafType && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Grass color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        葉片類型
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.LeafType}</Typography>
                            </Grid>}
                            {info.GrowthSeason && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <CalendarMonth color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        生長季節
                                    </Typography>
                                </Box>
                                <SeasonTransform text={info.GrowthSeason} />
                            </Grid>}
                            {info.GrowthRate && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Speed color="success" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        生長率
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.GrowthRate}</Typography>
                            </Grid>}
                            <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Thermostat color="error" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        理想溫度
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.IdealTemperature}℃</Typography>
                            </Grid>
                            <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <WaterDrop color="info" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        澆水
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.Water}</Typography>
                            </Grid>
                            <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <LightMode color="warning" />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        日照
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.Sunlight}</Typography>
                            </Grid>
                            {info.SoilType && <Grid size={{xs: 12, sm: 6, md: 4}}>
                                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                                    <Fence sx={{ color: 'brown' }} />
                                    <Typography color="success.dark" sx={{ fontWeight: 'bold' }} variant="subtitle1">
                                        土壤類型
                                    </Typography>
                                </Box>
                                <Typography variant="body1">{info.SoilType}</Typography>
                            </Grid>}
                        </Grid>
                        {info.WaterDetail && <>
                            <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                                澆水
                            </Typography>
                            <Typography variant="body1">
                                {info.WaterDetail}
                            </Typography>
                        </>}
                        {info.Fertilize && <>
                            <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                                施肥
                            </Typography>
                            <Typography variant="body1">
                                {info.Fertilize}
                            </Typography>
                        </>}
                        {info.Pruning && <>
                            <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                                修剪
                            </Typography>
                            <Typography variant="body1">
                                {info.Pruning}
                            </Typography>
                        </>}
                        {info.Propagation && <>
                            <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                                繁殖
                            </Typography>
                            <Typography variant="body1">
                                {info.Propagation}
                            </Typography>
                        </>}
                        {info.Repotting && <>
                            <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                                換盆
                            </Typography>
                            <Typography variant="body1">
                                {info.Repotting}
                            </Typography>
                        </>}
                        {info.InterestingFacts && <>
                            <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                                植物趣聞
                            </Typography>
                            <Typography variant="body1">
                                {info.InterestingFacts}
                            </Typography>
                        </>}
                        {info.ToxicityDetail && <>
                            <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                                毒性
                            </Typography>
                            <Typography variant="body1">
                                {info.ToxicityDetail}
                            </Typography>
                        </>}
                        {info.WeedControl && <>
                            <Typography color="success.dark" sx={{ fontWeight: 'bold', mt: 2 }} variant="h6">
                                雜草防治
                            </Typography>
                            <Typography variant="body1">
                                {info.WeedControl}
                            </Typography>
                        </>}
                        <GridImages id={plant} />
                        <Typography variant="body2">
                            植物資訊由
                            <Link href="https://www.picturethisai.com/zh-tw/" rel="noopener" target="_blank">
                                PictureThis
                            </Link>
                            提供
                        </Typography>
                        <BoxIntroBoard id={plant} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>{Text.Common.Close[language]}</Button>
                    </DialogActions>
                </>}
        </Dialog>
    );
};

export default PlantInfo;